/* eslint-disable import/no-default-export */
import Chance from 'chance';

const chance = new Chance();

const CREDENTIAL_TYPES = ['licence'] as const;
export type CredentialType = (typeof CREDENTIAL_TYPES)[number];

export default (credentialType: CredentialType) => {
  switch (credentialType) {
    case 'licence':
      const ahpraLicence = {
        result: 'Pharmacist',
      };

      const driversLicence = {
        result: 'Verified Valid Drivers Licence',
      };

      return chance.bool() ? ahpraLicence : driversLicence;
  }
};
